<div class="coupons-page">
  <div class="page-header">
    <div>
      <h1>Gestión de Cupones</h1>
      <p class="subtitle" *ngIf="!loading">Total: {{ totalElements }} cupones</p>
    </div>
    <button mat-raised-button color="primary" (click)="openCouponDialog()">
      <mat-icon>add</mat-icon>
      Crear cupón
    </button>
  </div>

  <mat-card *ngIf="error" class="error-card">
    <mat-icon color="warn">error</mat-icon>
    <span>{{ error }}</span>
  </mat-card>

  <div *ngIf="loading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Cargando cupones...</p>
  </div>

  <div *ngIf="!loading && !error" class="table-container">
    <table mat-table [dataSource]="coupons" class="coupons-table">

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef>Código</th>
        <td mat-cell *matCellDef="let coupon">
          <strong class="coupon-code">{{ coupon.code }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let coupon">
          <span class="description-text">{{ coupon.description }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="discountType">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let coupon">
          <mat-chip-set>
            <mat-chip [class.type-percentage]="coupon.discountType === 'percentage'"
                      [class.type-fixed]="coupon.discountType === 'fixed'">
              {{ discountLabel(coupon) }}
            </mat-chip>
          </mat-chip-set>
        </td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Valor</th>
        <td mat-cell *matCellDef="let coupon">
          <strong>{{ amountLabel(coupon) }}</strong>
        </td>
      </ng-container>

      <ng-container matColumnDef="autoApply">
        <th mat-header-cell *matHeaderCellDef>Automático</th>
        <td mat-cell *matCellDef="let coupon">
          <mat-chip-set *ngIf="coupon.applyAutomatically; else noAutoApply">
            <mat-chip class="type-auto" matTooltip="Se aplica solo, sin código, a los usuarios elegibles">
              <mat-icon class="chip-icon">bolt</mat-icon>
              Sí
            </mat-chip>
          </mat-chip-set>
          <ng-template #noAutoApply>
            <span class="info-text">—</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="validity">
        <th mat-header-cell *matHeaderCellDef>Vigencia</th>
        <td mat-cell *matCellDef="let coupon">
          <span class="info-text">{{ validityLabel(coupon) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="redemptions">
        <th mat-header-cell *matHeaderCellDef>Redenciones</th>
        <td mat-cell *matCellDef="let coupon">
          <span class="info-text">{{ redemptionsLabel(coupon) }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let coupon">
          <mat-slide-toggle
            [checked]="coupon.isActive"
            (change)="toggleStatus(coupon, $event.checked)">
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let coupon">
          <button mat-icon-button color="primary" matTooltip="Editar cupón" (click)="openCouponDialog(coupon)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>

    <p class="empty-message" *ngIf="!coupons.length">No hay cupones registrados.</p>
  </div>

  <mat-paginator
    *ngIf="!loading && coupons.length > 0"
    [length]="totalElements"
    [pageSize]="pageSize"
    [pageIndex]="page"
    [pageSizeOptions]="[5, 10, 25, 50]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>
</div>
